var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IconButton',{attrs:{"clickHandler":_vm.clickHandler,"height":_vm.height,"title":_vm.title,"disabled":_vm.disabled,"viewBox":"0 0 320 512","path":"M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }